/**
 * The mouse button being pressed.
 */
export enum PointerButton {
  Left = 'Left',
  Middle = 'Middle',
  Right = 'Right',
  Unknown = 'Unknown',
  NoButton = 'NoButton'
}
